module.exports = __webpack_public_path__ + "img/ground_choose_no.e2d5df41.svg";